import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import PaginationPanel from './pagination/PaginationPanel';
import HeaderComponent from './header/HeaderComponent';

import "./table.css";

const sortConverter = {
  toReactTable: (sortBy) => sortBy.map(s => ({ id: s.id, desc: s.value === 'desc' })),
  toServerSide: (sortBy) => sortBy.map(s => ({ id: s.id, value: s.desc ? 'desc' : 'asc' }))
};

const filterConverter = {
  toReactTable: (filterBy, columns) => filterBy.map(filter => {
    const def = columns && columns.find(c => c.filterId === filter.id);
    return def ? { id: def.id, value: filter.value } : filter;
  }),
  toServerSide: (filterBy, columns) => filterBy.map(filter => {
    const def = columns && columns.find(c => c.id === filter.id && c.filterId);
    return def ? { id: def.filterId, value: filter.value } : filter;
  })
};

const ReportTable = ({ loading, paging, columns, filteredBy, sortedBy, onFilteredChange, onPageChange, onPageSizeChange, onSortedChange, additionalToolbarButtons, data, ...props }) => <ReactTable
  ThComponent={HeaderComponent}
  columns={columns}
  loading={loading}
  loadingText="Wczytuje dane..."
  noDataText="Nie znaleziono danych"
  data={[...data || []]} // should default to []
  manual // informs React Table that you'll be handling sorting and pagination server-side
  className=" -highlight -dense"
  pageText="Ilość danych:"
  defaultPageSize={paging.pageSize}
  pageSizeOptions={[20, 100, 150, 200]}
  page={paging.pageNumber} // should default to -1 (which means we don't know how many pages we have)
  pages={paging.totalPages}
  minRows={20}
  onPageChange={onPageChange}
  onPageSizeChange={onPageSizeChange}
  canNext={paging.pageNumber < paging.totalPages}
  canPrevious={paging.pageNumber > 1}
  PaginationComponent={PaginationPanel}
  getPaginationProps={() => ({ totalSize: paging.totalSize, additionalButtons: additionalToolbarButtons })}
  sorted={sortConverter.toReactTable([...sortedBy])}
  onSortedChange={sortBy => onSortedChange(sortConverter.toServerSide(sortBy))}
  sortable
  filtered={filterConverter.toReactTable([...filteredBy], columns)}
  filterable
  onFilteredChange={filterBy => onFilteredChange(filterConverter.toServerSide(filterBy, columns))}
  {...props}
/>;

ReportTable.propTypes = {
  loading: PropTypes.bool,
  paging: PropTypes.object,
  filteredBy: PropTypes.array,
  sortedBy: PropTypes.array,
  data: PropTypes.array,
  columns: PropTypes.array,
  additionalToolbarButtons: PropTypes.node,
  onFilteredChange: PropTypes.func,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSortedChange: PropTypes.func,
  bikeTypes: PropTypes.array
};

ReportTable.defaultProps = {
  columns: [],
  loading: false,
  paging: {},
  filteredBy: [],
  sortedBy: [],
  additionalToolbarButtons: [],
  data: [],
  onFilteredChange: () => { },
  onPageChange: () => { },
  onPageSizeChange: () => { },
  onSortedChange: () => { },
};

export default ReportTable;
